// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.EditSolid = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EditSolid = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var EditSolid = _exports.EditSolid = function EditSolid(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_9564_34157)"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      x: "1",
      y: "1",
      width: "18",
      height: "18",
      rx: "9",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM13.9766 5.45703L14.5391 6.01953C15.1484 6.62891 15.1484 7.61719 14.5391 8.23047L13.7031 9.06641L10.9297 6.29297L11.7656 5.45703C12.375 4.84766 13.3633 4.84766 13.9766 5.45703ZM5.93359 11.2891L10.043 7.17969L12.8164 9.95312L8.70703 14.0586C8.54688 14.2188 8.34766 14.332 8.125 14.3867L5.77734 14.9727C5.5625 15.0273 5.33984 14.9648 5.18359 14.8086C5.02734 14.6523 4.96484 14.4297 5.01953 14.2148L5.60547 11.8672C5.66016 11.6484 5.77344 11.4453 5.93359 11.2852V11.2891Z",
      fill: "currentColor"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_9564_34157"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "currentColor"
    }))));
  };
});
